import { VisitCounter } from "./VisitCounter";

interface HeaderProps {
  latestCollectedAt: string | null;
  generatedAt: string | null;
  totalPapers: number;
  runCount: number;
}

export function Header({ latestCollectedAt, generatedAt, totalPapers, runCount }: HeaderProps) {
  return (
    <header className="sticky top-0 z-20 border-b border-slate-200 bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/60">
      <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-4 sm:px-6">
        <div className="flex items-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent text-white shadow-sm">
            <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M6 2C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2H6ZM12 14L13 16L15 17L13 18L12 20L11 18L9 17L11 16L12 14ZM16 16.5L16.5 18L18 18.5L16.5 19L16 20.5L15.5 19L14 18.5L15.5 18L16 16.5Z" />
              <path fillOpacity="0.5" d="M13 3.5V9H18.5L13 3.5Z" />
            </svg>
          </div>
          <div>
            <h1 className="text-base font-bold leading-none text-slate-900">Daily ArXiv</h1>
            <p className="text-[10px] font-medium text-slate-500">AI Research Digest</p>
          </div>
        </div>

        <div className="flex items-center gap-4 text-xs font-medium text-slate-500">
          <div className="hidden sm:block">
            共 {totalPapers} 篇 / {runCount} 次抓取
          </div>
          <VisitCounter />
        </div>
      </div>
    </header>
  );
}